import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modalsetrobpresent extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_comment:"",
   id_bn:"",
   statuscomment_bn:"",
   filewordcomment_bn:null,

   idarticlebn:'',

   id_articlepsf:'',
   id_emp:'',
   rob:'',



   statusbn:'',
   bn_commentbn:'',
   send_uploadcommentepdfbn:null,




   Expertpsf:[],

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.getExpertpsf = this.getExpertpsf.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.getExpertpsf()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({rob: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_articlepsf:this.props.id_articlepsf,
                       id_emp:this.props.id_emp,

                        // idarticlebn:this.props.idarticlebn,
                        // nameuserbn:this.props.nameuserbn,
                        // send_uploadewordbn:this.props.send_uploadewordbn,
                        // send_uploadewordbn2:this.props.send_uploadewordbn2,
                        // send_uploadewordbn3:this.props.send_uploadewordbn3,
                        // send_uploadewordbn4:this.props.send_uploadewordbn4,

                        // send_uploadepdfbn:this.props.send_uploadepdfbn,
                        // send_uploadepdfbn2:this.props.send_uploadepdfbn2,
                        // send_uploadepdfbn3:this.props.send_uploadepdfbn3,
                        // send_uploadepdfbn4:this.props.send_uploadepdfbn4,
                    //   id_bn:this.props.id_bn,
        })
    //   this.setState({ id_bn:this.props.expert_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}


getExpertpsf() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       api.get('registercon/Selectexpertpsf')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expertpsf: res.data})
      }) 

    }, 0);

}

handleChange(event) {    this.setState({statusbn: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadcommentepdfbn: event.target.files[0]});  }


  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);


     for (let index = 0; index < this.state.Expertpsf.length; index++) {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

 //  setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idarticlebn", this.state.idarticlebn);
      datafrm.append("id_articlepsf", this.state.id_articlepsf);
      datafrm.append("id_empbn", this.state.id_empbn);
      datafrm.append("statusbn", this.state.statusbn);
      datafrm.append("date_senbackbn", dates);
      datafrm.append("nameuserbn", this.state.nameuserbn); //.ใช้insert ผู้ทรง
      datafrm.append("send_uploadewordbn", this.state.send_uploadewordbn);
      datafrm.append("send_uploadewordbn2", this.state.send_uploadewordbn2);
      datafrm.append("send_uploadewordbn3", this.state.send_uploadewordbn3);
      datafrm.append("send_uploadewordbn4", this.state.send_uploadewordbn4);
      datafrm.append("send_uploadepdfbn", this.state.send_uploadepdfbn);
      datafrm.append("send_uploadepdfbn2", this.state.send_uploadepdfbn2);
      datafrm.append("send_uploadepdfbn3", this.state.send_uploadepdfbn3);
      datafrm.append("send_uploadepdfbn4", this.state.send_uploadepdfbn4);
      datafrm.append("dateaddex", dates);
      datafrm.append("statusex", '1');
      datafrm.append("id_expert", this.state.Expertpsf[index].id_expert);

      api.post("registercon/updatebncommentlist",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
    if (res.data = '200') {
                if (this.state.Expertpsf.length === index+1) {

                      Swal.fire({
                      title: 'บันทึกข้อเสนอแนะสำเร็จ',
                      text: "Suggestion saved successfully",
                      icon: 'success',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'ตกลง'
                    }).then((result) => {
                      if (result.isConfirmed) {
                          this.props.list()
                          this.toggle()
                          window.location.href = '/expertbn'
                      }
                    })


                 }

       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })


//}, 1000);

     }

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

    const rro = "รอบ"+this.state.rob;
   // console.log(dates)
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      //datafrm.append("idarticlebn", this.state.idarticlebn);
      datafrm.append("id_articlepsf", this.state.id_articlepsf);
      datafrm.append("id_emp", this.state.id_emp);
      datafrm.append("rob", rro);

  

      
      api.post("registercon/updaterobpresent",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกรอบประชุมสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

  

    render() {

      // console.log(this.state.id_bn);
      // console.log(this.state.id_comment)
      // console.log(this.state.id_send)
      
        

        return (
            <>
            <MDBBtn color="brown" className="rounded-pill" onClick={this.toggle} size='sm'>กำหนดรอบประชุม</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>
              กำหนดรอบประกอบการประชุม
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              <div className="mb-2">
                           <label><strong>รอบที่เข้าประชุม</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.rob} placeholder="กรุณาระบุรอบ" required />
              </div>


               {/* <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="2">ผ่าน</option>
                        <option value="0">ปรับแก้ไข</option>
                </select>
                </div> */}

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}
           

{this.state.statusbn === '2' ?<>

</>:<>

{this.state.statusbn === '0' ?<>
                           <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.bn_commentbn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
                           </div>

                           <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมิน <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required />
                            </div>

</>:<></>}
</>}
               
                      
            
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
               
              

                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


